import * as React from "react"

function WhatsApp(props) {
  return (
    <svg
      viewBox="0 0 55 56"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <circle
        cx={52.026}
        cy={101.451}
        r={20.568}
        fill="#e5eeff"
        transform="matrix(1.33317 0 0 1.35308 -41.939 -109.441)"
      />
      <g fill="#052879">
        <path d="M21.109 16.43c-.04 0-.121 0-.161.04-1.81.563-3.056 1.528-3.74 2.774-.683 1.247-.763 2.734-.482 4.262.603 3.015 2.694 6.272 5.307 8.966 2.654 2.694 5.83 4.865 8.846 5.508 1.528.322 3.015.241 4.342-.442 1.287-.684 2.332-1.97 2.975-3.78.12-.361 0-.723-.321-.924l-5.71-3.578c-.04 0-.04-.04-.08-.04-.08-.04-.16-.081-.282-.121h-.12c-.12 0-.282 0-.402.08-.04.04-.08.04-.12.08-.041 0-.041.04-.081.04 0 0 0 .04-.04.04-.04.041-.08.041-.08.081l-1.247 1.287c-2.292-1.166-4.02-3.056-5.589-5.67l1.166-1.125c.04 0 .04-.04.08-.08l.161-.161c0-.04 0-.04.04-.08v-.04s0-.041.04-.041v-.442c0-.04-.04-.08-.04-.12 0-.041-.04-.081-.04-.081v-.04l-3.578-5.87c-.16-.242-.402-.362-.684-.403-.08-.12-.12-.12-.16-.12zm-.282 1.769l2.935 4.825-1.206 1.206a.786.786 0 00-.12.965c1.849 3.216 4.06 5.709 7.156 7.076.322.12.643.08.885-.16l1.286-1.287 4.704 2.935c-.522 1.166-1.206 1.89-1.97 2.291-.884.483-2.01.563-3.256.322-2.533-.523-5.549-2.493-8.042-5.026-2.492-2.533-4.382-5.629-4.905-8.121-.241-1.247-.12-2.332.322-3.177.402-.764 1.085-1.407 2.211-1.85z" />
        <path d="M27.421 9.595c-9.77 0-17.69 7.92-17.69 17.69 0 3.539 1.045 6.876 2.894 9.69l-1.97 6.594c-.12.442.12.884.523 1.005.16.04.321.04.482 0l6.473-2.211a17.733 17.733 0 009.288 2.613c9.77 0 17.69-7.92 17.69-17.69 0-9.77-7.92-17.691-17.69-17.691zm0 1.608c8.886 0 16.082 7.197 16.082 16.082 0 8.886-7.196 16.083-16.082 16.083-3.217 0-6.232-.965-8.725-2.573-.2-.12-.482-.161-.683-.08l-5.348 1.849 1.649-5.468a.702.702 0 00-.12-.684c-1.81-2.653-2.856-5.79-2.856-9.127a16.052 16.052 0 0116.083-16.082z" />
      </g>
    </svg>
  )
}

export default WhatsApp
